import { BidIcon } from "@/component/Icons";
import addTurnIcon from "@assets/web-v3-images/icons/add-turn.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

/**
 * Pill số lượt đấu giá + nút "+" tràn ở mép phải. Tách khỏi HomeHeader để trang
 * Daily Reward dùng lại (ở đó pill đứng một mình, không kèm avatar/tên).
 *
 * Nền và viền đều là gradient: border trong suốt, background 2 lớp
 * (padding-box = ruột pill, border-box = viền) vì `border-color` không nhận
 * gradient.
 *
 * `className` để nơi gọi chỉnh kích thước — HomeHeader giữ nguyên thang cũ,
 * Daily Reward dùng thang nhỏ hơn theo design.
 */
const TurnsPill = ({
  turns = 0,
  onAddTurns,
  // Rộng theo nội dung (bỏ w cố định) + pr đủ để chữ không lọt xuống dưới nút "+"
  // ở mọi breakpoint (nút to dần: ~24/32/40px). Nhờ vậy text dài không bị che.
  className = "h-9 pl-8 pr-9 md:h-12 md:border-[3px] md:py-1.5 md:pl-13 md:pr-11",
  iconClassName = "size-9 md:size-12",
  textClassName = "text-xs md:text-base",
  addButtonClassName = "size-6 right-0.5 md:right-1 md:size-8",
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`intro-tour-home__step-2 relative flex items-center gap-1.5 rounded-full border-2 border-transparent [background:linear-gradient(to_right,#FDDCAE,#FFFFFF_50%,#FFE7CD)_padding-box,linear-gradient(to_right,#FFB86C,#FFE8D0_50%,#FFD8A1)_border-box] py-1 ${className}`}
    >
      <div className="absolute left-0 translate-x-[-20%]">
        <BidIcon className={iconClassName} />
      </div>
      <span className={`whitespace-nowrap font-bold text-[#8a3213] ${textClassName}`}>
        {turns} {t("home.header.turns")}
      </span>
      <button
        type="button"
        onClick={onAddTurns}
        aria-label={t("home.header.addTurns")}
        className={`btn-click-active absolute grid place-items-center ${addButtonClassName}`}
      >
        {/* SVG đã có sẵn nền tròn cam + dấu cộng nên bỏ gradient/rounded của button */}
        <img
          src={addTurnIcon}
          alt=""
          width={40}
          height={40}
          className="aspect-square size-full"
        />
      </button>
    </div>
  );
};

export default TurnsPill;
